import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import { StudioStarMark } from '../../StudioMarks';
import SpotlightFrame, { type SpotlightInjectedProps, type SpotlightLayoutProps } from './SpotlightFrame';

const SpotlightCoverContent: React.FC<SpotlightInjectedProps & { content: any }> = ({ content, tokens, isStory }) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const highlights = Array.isArray(content.bullets) ? content.bullets : [];

  return (
    <div>
      {content.kicker ? (
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: isStory ? '7px 12px' : '6px 10px',
            color: t.onAccent,
            background: t.accent,
            fontSize: typeSize(isStory ? 10.5 : 9),
            fontWeight: 900,
            letterSpacing: 1.3,
            textTransform: 'uppercase',
            transform: 'rotate(-2deg)'
          }}
        >
          <StudioStarMark size={typeSize(isStory ? 10.5 : 9)} />
          {content.kicker}
        </div>
      ) : null}
      <h1
        style={{
          maxWidth: 310,
          margin: content.kicker ? (isStory ? '25px 0 0' : '18px 0 0') : 0,
          color: t.ink,
          fontSize: typeSize(isStory ? 48 : 38),
          fontWeight: 900,
          letterSpacing: '-2.1px',
          lineHeight: 0.98
        }}
      >
        {content.title}
      </h1>
      <div
        style={{
          width: isStory ? 88 : 70,
          height: isStory ? 7 : 5,
          marginTop: isStory ? 23 : 17,
          background: t.accent,
          transform: 'skewX(-22deg)'
        }}
      />
      {content.subtitle ? (
        <p
          style={{
            maxWidth: 292,
            margin: isStory ? '21px 0 0' : '15px 0 0',
            color: t.muted,
            fontSize: typeSize(isStory ? 15 : 12.8),
            fontWeight: 600,
            lineHeight: 1.55
          }}
        >
          {content.subtitle}
        </p>
      ) : null}
      {highlights.length ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7, marginTop: isStory ? 25 : 18 }}>
          {highlights.map((highlight: string, index: number) => (
            <span
              key={`${index}-${highlight}`}
              style={{
                padding: isStory ? '6px 10px' : '5px 8px',
                border: `1px solid ${t.line}`,
                borderRadius: 999,
                color: t.ink,
                background: t.panel,
                fontSize: typeSize(isStory ? 10.5 : 8.8),
                fontWeight: 700
              }}
            >
              {highlight}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
};

const SpotlightCoverLayout: React.FC<SpotlightLayoutProps> = props => (
  <SpotlightFrame {...props}>
    <SpotlightCoverContent content={props.content || {}} />
  </SpotlightFrame>
);

export default SpotlightCoverLayout;
